// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"9e8bc547","402":"75c12eb1","787":"2bc59197"}[chunkId] + ".chunk.js";
};